<template>
  <div class="col2-wrapper">
    <slot name="sidebar" />
    <div v-if="mainWrapper" class="col2-main-wrapper">
      <slot />
    </div>
    <slot v-else />
  </div>
</template>

<script setup lang="ts">
/**
 * 支給デザインの2カラム骨格。左に `.sidebar`、右に `.col2-main-wrapper`。
 * sidebar の中身（`sidebar-btns` / `sidebar-nav` / `sidebar-banners`）は PR-B で作成済み。
 *
 * **PC サイドバーが無いページの方が多い**（第6便101本の実測で 63/101）。`#sidebar` スロットへ
 * 何も渡さなければ `<aside>` は出ないので、それらのページで追加の指定は要らない。
 *
 * **`col2-main-wrapper` を持たないページが39本ある**（商品詳細38 ＋ `set-discount`）。
 * 支給は `col2-wrapper` の直下が `sec_product-detail` になっている
 * （`design-src/20260810/product-detail/product501.html:323-324`）。
 * `.col2-main-wrapper` の CSS は `width: 100%` だけ（`renewal/style.css:1003`）なので
 * 見た目は変わらないが、支給どおりの DOM に揃えるため `main-wrapper` を `false` で渡す。
 * → CONVERSION-GUIDE.md 決定#53
 */
type Props = {
  /** `col2-main-wrapper` で包むか。商品詳細と `/set` だけ `false` */
  mainWrapper?: boolean;
};

withDefaults(defineProps<Props>(), {
  mainWrapper: true,
});
</script>
